<script>
  import { getContext } from "svelte";
  import { Link } from "svelte-routing";
  import SidebarSection from "./SidebarSection.svelte";

  export let group;

  const shpxAssistPages = getContext("shpxAssistPages");
  const fileData = getContext("fileData");

  const statusColors = {
    processing: "#00B9A7",
    submitted: "#00B9A7",
    complete: "#3AA4FF",
    flagged: "#FF5E68",
    canceled: "#999",
  };

  $: assistPages = getAssistPages($shpxAssistPages, $group, $fileData);

  function getAssistPages(p, grp, fd) {
    return Object.keys(p)
      .sort((a, b) => {
        return grp.documents.indices(a) - grp.documents.indices(b);
      })
      .reduce((acc, docId) => {
        const pages = p[docId];

        const sdoc = grp.documents[docId];
        const doc = sdoc?.type === "virtual" ? grp.documents[sdoc.source_document_id] : sdoc;

        if (doc) {
          Object.keys(pages).forEach((pageId) => {
            const req = pages[pageId];
            const page = doc.data.pages[pageId];
            const index = doc.data.pages.indices[pageId];
            const label = page.label || fd[page.name]?.sheets?.[page.page]?.name || `Page ${index + 1}`;
            if (req.status !== "acknowledged") {
              // @ts-ignore
              acc.push({
                document_id: sdoc.id,
                page_id: pageId,
                label,
                index,
                status: req.status,
              });
            }
          });
        }

        return acc;
      }, []);
  }
</script>

<SidebarSection>
  {#if assistPages.length}
    <h3 class="px-2 mb-2">SHPX Assist Requests</h3>
    <div class="px-2">
      {#each assistPages as page (page.page_id)}
        <Link to={`/jobs/${$group.job_id}/documents/${page.document_id}?doc-page=${page.page_id}`}>
          <div class="flex items-center justify-between py-0.5">
            <div>
              {page.label}
            </div>

            <div
              class="px-2 py-0.5 rounded-full uppercase text-white text-xxs"
              style="background-color: {statusColors[page.status] || '#000'};">
              {page.status}
            </div>
          </div>
        </Link>
      {/each}
    </div>
  {/if}
</SidebarSection>
